<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mb-2,mt-2"
        style="margin-right:0.5em; border-radius:8px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Get Division Time Table</v-toolbar-title>
                <v-divider class="mx-4" color="white" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <!-- <v-card-text> -->
            <!-- <v-row justify="center">
                    <v-col sm="3">
                        <h3>Get Division Time Table</h3>
                    </v-col>
                </v-row> -->
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-combobox rounded dense required v-model="sel_ay_data" return-object :items="ay_std_div_list"
                        item-text="ay" label="Academic Year" outlined @change="getStd(); getTimeTableVersion()"
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-combobox rounded dense required v-model="sel_std_data" return-object :items="std_div_list"
                        item-text="std" label="Standard" outlined @change="getDiv();tt_version = null" persistent-hint
                        hint="Please Select Standard" />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-combobox rounded dense required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Division" outlined persistent-hint hint="Please Select Division" />
                </v-col>
                <v-col sm="2" v-if="sel_ay_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="tt_version" :items="tt_version_list"
                        item-text="name" item-value="id" label="Version" outlined @change="getData" persistent-hint
                        hint="Please Select Version" />
                </v-col>
            </v-row>
        </v-card>
        <div-time-table v-if="show_tt == true" :div_id="div.div_off_id" :tt_version="tt_version" :sel_ay="sel_ay_data.ay_id"
            :key="tt_version"></div-time-table>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Get Div Time-Table Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/-pC29MzXLqI?si=DQ-OMSvHiqByIA2P"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import DivTimeTable from "./DivTimeTable";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        "div-time-table": DivTimeTable,
        Breadcrumbs
    },
    data() {
        return {
            snackbar_msg: "",
            color: "",
            snackbar: false,
            videoDialog:false,
            ay_std_div_list: null,
            sel_ay_data: null,
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            show_tt: false,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            tt_version_list: [],
            tt_version: null
        };
    },
    methods: {
        getTimeTableVersion() {
            const data = {
                ay: this.sel_ay_data.ay,
            };
            axios
                .post("/timeTable/getTTVersion", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        // this.showSnackbar("success", "Success...");
                        this.tt_version_list = res.data.tt_version_list;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("error", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
        },
        getStd() {
            this.show_tt = false;
            this.std_div_list = null;
            this.sel_std_data = null;
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
        },
        getDiv() {
            // this.show_tt = true
            this.show_tt = false;
            this.div_list = null;
            this.div = null;
            this.div_list = this.sel_std_data.div_list;
            if (this.div_list.length == 0) {
                alert("No division found!!!");
                this.div_list = null;
                this.sel_std_data = null;
            }
        },
        getData() {
            //console.log("div:"+this.div)
            this.show_tt = true;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        //this.uid = localStorage.getItem("EPS-uid")
        axios
            .post("/commonAPI/get_ay_std_div")
            .then((res) => {
                this.ay_std_div_list = res.data.data;
            })
            .catch((error) => {
                alert("Somthing went wrong!!!");
            })
            .finally(() => {
                //stop loader
            });
    },
};
</script>
